import axios, { AxiosInstance } from "axios";
import { Config, loadConfig } from "../../config";

let axiosInstance: AxiosInstance | null = null;

export const getAxiosInstance = async (): Promise<AxiosInstance> => {
  if (!axiosInstance) {
    const config: Config = await loadConfig();
    axiosInstance = axios.create({
      baseURL: config.baseApiUrl,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  return axiosInstance;
};
